import PropTypes from 'prop-types'
import { Tabs } from 'antd'
import { StyledTabs } from './styles'

const { TabPane } = Tabs

// Styled Rate
export const TB = ({ type = '', tabs, ...rest }) => {
  return (
    <StyledTabs>
      <Tabs {...rest} id={type} type={type}>
        {tabs.map((data) => {
          return (
            <TabPane tab={data.tab} key={data.key} disabled={data.is_disabled ? data.is_disabled : false}>
              {data.content}
            </TabPane>
          )
        })}
      </Tabs>
    </StyledTabs>
  )
}

TB.propTypes = {
  type: PropTypes.string,
  tabs: PropTypes.array.isRequired
}

// End of Styled Rate
